import Container from "../../../../../src/components/container/Container";
import { Playground, Props } from 'docz';
import * as React from 'react';
export default {
  Container,
  Playground,
  Props,
  React
};